import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux'
import Topbar from '../Topbar/';

import Button from '@material-ui/core/Button';

import { logout } from './actions'

class Settings extends Component {
  constructor() {
    super();
  }


  logout = () => {
    this.props.logout()
  }

  render() {

    return (
      <div style={ { backgroundColor: 'black' } } className="h-100 d-flex flex-column">
        <Topbar/>
        <div className="flex-1 flex-column d-flex justify-content-center align-items-center">
          <Button onClick={ () => this.logout() } variant="contained" color="primary">
            Log Out
          </Button>
          <br/>
        </div>
      </div>
      );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user
})

export default connect(mapStateToProps, {
  logout
})(Settings)


// WEBPACK FOOTER //
// ./src/Components/Settings/index.js